import $api from "@/frontend/shared/api/axios";

export async function getSearchExpertCompanies({ name, page = 1 }: { name: string; page?: number }) {
  const response = await $api.get(`/portfolio-companies/search?query=${name || ""}&page=${page}`);
  return response.data;
}
